import React from 'react';
import { getBgColor, simplifyFulfillmentStatus } from '../../../utils/orderTableHelper';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { upperFirst } from 'lodash';

export default function StatusBadge(props) {
  const {
    id,
    status,
    className,
    pill = true,
    additionalInfo = false,
    isOrderTypeStatus = false,
    postShipmentStatus = false,
  } = props;

  const tooltipAppearance = (status) => {
    return status.hoverInfo?.length ? (
      <Tooltip id={`${id}_${status.state}`}>
        <h5>{status.hoverInfo}</h5>
      </Tooltip>
    ) : (
      <></>
    );
  };
  const badgeState = (state) => {
    const stateInfo = props.simplify ? simplifyFulfillmentStatus(state) : state.replace(/_/g, ' ');
    const bgColor = getBgColor({
      label: stateInfo,
      additionalInfo,
      options: { isOrderTypeStatus },
    });

    const currentState = stateInfo.state ?? stateInfo;
    return (
      <OverlayTrigger key={`${id}_${currentState}`} placement="bottom" overlay={tooltipAppearance(stateInfo)}>
        {!postShipmentStatus ? (
          <Badge
            key={`${id}_${currentState}`}
            pill={pill}
            bg={bgColor}
            className={className}
            style={{ color: '#212529', fontSize: '14px', fontWeight: 'normal' }}
          >
            {upperFirst(currentState)}
          </Badge>
        ) : (
          <span>{upperFirst(currentState)}</span>
        )}
      </OverlayTrigger>
    );
  };

  return <>{Array.isArray(status) ? status.map((state) => badgeState(state)) : badgeState(status)}</>;
}
